// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
  width: 100%;
  height: 100vh;
  position: absolute;
  /* background: rgba(222, 218, 228, 0.834); */
  z-index: 1;
}

.loader {
  /* left: 50%; */
  margin-left: 20em;
  margin-top: 15em;
  margin-bottom: 40em;
  position: center;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #F8B518;
  border-bottom: 16px solid #F8B518;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.chip {
  display: inline-block;
  padding: 0 25px;
  height: 50px;
  font-size: 18px;
  line-height: 50px;
  border-radius: 25px;
  background-color: #f1f1f1;
  margin: 10px 1px 0;
}

.chip img {
  float: left;
  margin: 0 10px 0 -25px;
  height: 50px;
  width: 50px;
  border-radius: 50%;
}

.closebtnfilter {
  padding-left: 10px;
  color: #888;
  font-weight: bold;
  float: right;
  font-size: 20px;
  cursor: pointer;
}

.closebtnfilter:hover {
  color: #000;
}

.addwishlist-pop-up-box {
  float: right;
  bottom: 6px;
  position: fixed;
  background: #e5cb21 0% 0% no-repeat padding-box;
  box-shadow: 0px 12px 30px #757575;
  width: 40rem;
  right: 2px;
  border-radius: 41px 0px 0px 41px;
  max-width: 100%;
  /* padding: 10px; */
}

.add-wishlist-row-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.add-wishlist-row-section h5 {
  font: normal normal medium 20px/30px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
}

.add-wishlist-row-section img {
  width: 10%;
  cursor: pointer;
}

.select_for-box {
  height: 400px;
}
.searchBar{
  display: block;
  padding: 5px;
  width: 80%;
  margin: auto;
  margin-bottom: 20px;
  border: 2px solid yellow;
}

/* @media (min-width: 1200px) {
  .container {
    width: 90%;
  }
} */

@media(max-width:767px) {
  .select_for-box {
    height: inherit;
  }
}

@media(max-width:992px) {

  .loader {
    margin: auto;
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ProductList/loader.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;EACjC,YAAY;EACZ,aAAa;EAEb,kCAAkC;AACpC;;AAYA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,+CAA+C;EAC/C,iCAAiC;EACjC,YAAY;EACZ,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;;;GAIG;;AAEH;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":[".loader-container {\n  width: 100%;\n  height: 100vh;\n  position: absolute;\n  /* background: rgba(222, 218, 228, 0.834); */\n  z-index: 1;\n}\n\n.loader {\n  /* left: 50%; */\n  margin-left: 20em;\n  margin-top: 15em;\n  margin-bottom: 40em;\n  position: center;\n  border: 16px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 16px solid #F8B518;\n  border-bottom: 16px solid #F8B518;\n  width: 120px;\n  height: 120px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.chip {\n  display: inline-block;\n  padding: 0 25px;\n  height: 50px;\n  font-size: 18px;\n  line-height: 50px;\n  border-radius: 25px;\n  background-color: #f1f1f1;\n  margin: 10px 1px 0;\n}\n\n.chip img {\n  float: left;\n  margin: 0 10px 0 -25px;\n  height: 50px;\n  width: 50px;\n  border-radius: 50%;\n}\n\n.closebtnfilter {\n  padding-left: 10px;\n  color: #888;\n  font-weight: bold;\n  float: right;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.closebtnfilter:hover {\n  color: #000;\n}\n\n.addwishlist-pop-up-box {\n  float: right;\n  bottom: 6px;\n  position: fixed;\n  background: #e5cb21 0% 0% no-repeat padding-box;\n  box-shadow: 0px 12px 30px #757575;\n  width: 40rem;\n  right: 2px;\n  border-radius: 41px 0px 0px 41px;\n  max-width: 100%;\n  /* padding: 10px; */\n}\n\n.add-wishlist-row-section {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n}\n\n.add-wishlist-row-section h5 {\n  font: normal normal medium 20px/30px Poppins;\n  letter-spacing: 0px;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.add-wishlist-row-section img {\n  width: 10%;\n  cursor: pointer;\n}\n\n.select_for-box {\n  height: 400px;\n}\n.searchBar{\n  display: block;\n  padding: 5px;\n  width: 80%;\n  margin: auto;\n  margin-bottom: 20px;\n  border: 2px solid yellow;\n}\n\n/* @media (min-width: 1200px) {\n  .container {\n    width: 90%;\n  }\n} */\n\n@media(max-width:767px) {\n  .select_for-box {\n    height: inherit;\n  }\n}\n\n@media(max-width:992px) {\n\n  .loader {\n    margin: auto;\n    margin-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
